<template>
    <template v-if="!isEmpty">
        <div v-for="(booking, i) in bookings" :key="booking.id" class="mb-0 mt-0">
            <v-divider v-if="i !== 0" class="my-3" />
            <booking-card :model-value="booking" :disabled="disabled" @click:cancel-booking="$emit('click:cancel-booking', booking.id)" />
        </div>
    </template>
    <empty-state v-else class="mt-0">
        {{ t('yourBookings.noBookings') }}
    </empty-state>
</template>

<script setup lang="ts">
import { BookingDto } from '../../types';
import BookingCard from './BookingCard.vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import EmptyState from '@/features/common/components/EmptyState.vue';

interface IBookingCardList {
    bookings: BookingDto[];
    disabled?: boolean;
}

interface IBookingCardListEmits {
    (e: 'click:cancel-booking', bookingId: string): void;
}

const props = defineProps<IBookingCardList>();
defineEmits<IBookingCardListEmits>();

const isEmpty = computed(() => props.bookings.length === 0);
const { t } = useI18n();
</script>
